<template>
  <div class="container">
      <Label text="Usuarios" header="header-2"/>
        <div v-if="loading">
            <div class="text-center d-flex justify-content-between">
                <h4>Obteniendo datos, por favor espere...</h4>
                <b-spinner
                    :variant="dark"
                    :key="dark"
                    type="grow"
                ></b-spinner>
            </div>
        </div>
      <DataTable v-if="total_lines > 0" :fields="fields" :inputData="recordsData" />
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

import DataTable from '../../components/DataTable';
import Label from '../../components/Label';

export default {
    name: 'User',
    components: {
        DataTable,
        Label
    },
    data() {
        return {
            loading: false,
            user: {},
            axiosParams: {},
            total_lines: 0,
            recordsData: [],
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                username: {
                    label: 'USUARIO',
                    sortable: true
                },
                email: {
                    label: 'CORREO',
                    sortable: true,
                    tdClass: 'align-middle'
                },
                name: {
                    label: 'NOMBRE',
                    tdClass: 'align-middle'
                },
            },
            message: {},
        }
    },
    created: function() {
        const lsUser = Vue.localStorage.get('user');
        if (lsUser) {
          this.user = JSON.parse(lsUser);
          this.axiosParams = {
            headers: {
              'Authorization': this.user.access.key
            }
          }
          this.getUsers();
        }
    },
    methods: {
      getUsers : async function() {
        var vm = this;
        vm.loading = true;
        var url = process.env.VUE_APP_HOST + process.env.VUE_APP_PATH_ADMIN + 'users';
        await axios.get(url, vm.axiosParams).then(function(response) {
            vm.recordsData = [];
            var i = 1;
            response.data.forEach((item) => {
              var obj = {
                id: i++,
                name: item.name,
                email: item.email,
                username: item.username
              }
              vm.recordsData.push(obj);
            });
            vm.total_lines = vm.recordsData.length;
            vm.loading = false;
        }).catch(function(error) {
            vm.message = {
              msg: error,
              variant: 'danger',
              dismiss: 4
            }
            vm.loading = false;
            console.log(error);
        });
      }
    }
}
</script>